module.exports = __webpack_public_path__ + "static/media/facebook.aa728627.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/facebook.svg
// module id = 246
// module chunks = 1